import type { ConnectionEditState } from "../../viewmodels/board/connections/Connections.types";
import { parseConnectionConfiguration } from "../source-settings/SourceSettingsConfiguration";

interface TrelloStatusReference {
  id?: unknown;
}

interface TrelloConfigurationValidationModel {
  doneList?: TrelloStatusReference;
  listsToLoad?: TrelloStatusReference[];
}

const normalizeId = (value: unknown): string => String(value ?? "");

export const getTrelloSourceSettingsValidationMessage = (
  editingConnection: ConnectionEditState,
  t: (key: string) => string,
): string => {
  const configuration =
    parseConnectionConfiguration<TrelloConfigurationValidationModel>(
      editingConnection.configuration,
    );
  const doneListId = normalizeId(configuration.doneList?.id);

  if (!doneListId) {
    return "";
  }

  const listsToLoad = configuration.listsToLoad ?? [];
  return listsToLoad.some((list) => normalizeId(list.id) === doneListId)
    ? t("board.connections.dialog.sourceSettings.trello.statusReferenceError")
    : "";
};
